"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _lodash = require("lodash");
var _HBText = _interopRequireDefault(require("../HBText/HBText"));
var _mixins = require("../../styles/mixins");
var HBNewTableSelectableHeader = function HBNewTableSelectableHeader(_ref) {
  var _selectableProps$sele;
  var selectableProps = _ref.selectableProps;
  var showHeaderWrapper = !(selectableProps !== null && selectableProps !== void 0 && selectableProps.showTableHeaderOnSelect) && (selectableProps === null || selectableProps === void 0 || (_selectableProps$sele = selectableProps.selectedItemIds) === null || _selectableProps$sele === void 0 ? void 0 : _selectableProps$sele.length) > 0;
  var countItemsSelected = selectableProps.selectedItemIds.length;
  var showBulkActions = (0, _lodash.isFunction)(selectableProps === null || selectableProps === void 0 ? void 0 : selectableProps.renderBulkActionsComponent);
  var selectedText = "".concat(countItemsSelected, " SELECTED").concat(showBulkActions ? ': BULK ACTIONS' : '');
  return /*#__PURE__*/_react["default"].createElement(Container, null, showHeaderWrapper && /*#__PURE__*/_react["default"].createElement(HeaderWrapper, null, /*#__PURE__*/_react["default"].createElement(HeaderLeftWrapper, null, /*#__PURE__*/_react["default"].createElement(_HBText["default"], {
    type: "subtitle12",
    color: "textSecondary"
  }, selectedText), showBulkActions && selectableProps.renderBulkActionsComponent())));
};
var _default = exports["default"] = /*#__PURE__*/_react["default"].memo(HBNewTableSelectableHeader); // -------------------------------- Styles -------------------------------- //
var Container = _styledComponents["default"].div.withConfig({
  displayName: "HBNewTableSelectableHeader__Container",
  componentId: "sc-11nhfco-0"
})(["", " position:absolute;height:30px;"], _mixins.flexCenterVertical);
var HeaderWrapper = _styledComponents["default"].div.withConfig({
  displayName: "HBNewTableSelectableHeader__HeaderWrapper",
  componentId: "sc-11nhfco-1"
})(["display:flex;justify-content:space-between;padding-left:48px;height:30px;"]);
var HeaderLeftWrapper = _styledComponents["default"].div.withConfig({
  displayName: "HBNewTableSelectableHeader__HeaderLeftWrapper",
  componentId: "sc-11nhfco-2"
})(["display:flex;align-items:center;gap:12px;"]);
//# sourceMappingURL=HBNewTableSelectableHeader.js.map